import filterInspectors from './filterInspectors';
import { inspectorSelected, inspectorImage } from './mapIcons';
import { contentString } from '../utilities';
import { createCustomMarkerElement } from '../createCustomMarkerElement';

const getLocation = (inspector) => {
  if (inspector.geocode_results) return inspector.geocode_results.geometry;
  else if (inspector.geometry) return inspector.geometry;
  else return null;
};

// 1. Made function ASYNC
export default async function addInspectors({ inspector, inspectors, map }, pins, onClick, showInspectors = true) {
  
  // 2. Import the library
  const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

  // 3. Cleanup old pins
  for (let i in pins) {
    if (pins[i]) {
      // Advanced Markers use direct property assignment to remove from map
      pins[i].map = null; 
    }
  }

  if (!showInspectors) {
    return [filterInspectors(map, inspectors), {}];
  }

  const pp = {};

  // We use a simple loop instead of forEach to handle async flow cleanly if needed, 
  // though standard synchronous loop is fine here since we imported the lib at the start.
  const inspectorValues = Object.values(inspectors);
  
  for (const insp of inspectorValues) {
    const { id, name, phone, email, geocode_results, geometry } = insp;
    
    const g = getLocation({ geometry, geocode_results });
    if (!g || !g.location) continue; // Use continue in loop
    
    // Ensure lat/lng are numbers for AdvancedMarkerElement
    const lat = Number(g.location.lat);
    const lng = Number(g.location.lng);
    if (isNaN(lat) || isNaN(lng)) continue;
    
    // Create Position object explicitly to be safe
    const position = { lat, lng };

    const iconData = id === inspector.id ? inspectorSelected() : inspectorImage();
    
    // 4. Create Advanced Marker
    const marker = new AdvancedMarkerElement({
      position,
      map,
      title: name,
      // Ensure createCustomMarkerElement returns a DOM node (img or div)
      content: createCustomMarkerElement(iconData), 
    });

    const infoWindow = new window.google.maps.InfoWindow({
      content: contentString({ name, contact: name, phone, email }),
    });

    marker.addListener('click', () => {
      onClick(inspectors[id]);
    });

    marker.addListener('mouseout', () => {
      infoWindow.close();
    });

    if (id === inspector.id) {
      // 5. Updated InfoWindow syntax for Advanced Markers
      infoWindow.open({
        anchor: marker,
        map,
      });
    }

    pp[id] = marker;
  }

  return [filterInspectors(map, inspectors), pp];
}